import React from 'react';
// template components
import Col from '@nmx/template/dist/componentLibrary/foundations/Grid/Col';
import Row from '@nmx/template/dist/componentLibrary/foundations/Grid/Row';
import SectionContainer from '@nmx/template/dist/componentLibrary/components/SectionContainer';
import Typography from '@nmx/template/dist/componentLibrary/foundations/Typography';

export default () => (
  <SectionContainer id='legal-name'>
    <Row align='center'>
      <Col medium={10}>
        <Typography
          component='h1'
          nextElement='typography'>
          Legal Name
        </Typography>
        <Typography disableBottomPadding>
          <Typography
            component='span'
            disableBottomPadding>
            Issuer:
          </Typography>
          <Typography
            weight={600}
            component='span'
            disableBottomPadding>
            &#160;The Northwestern Mutual Life Insurance Company, Milwaukee, Wisconsin.
          </Typography>
        </Typography>
      </Col>
    </Row>
  </SectionContainer>
);
